// extracted by mini-css-extract-plugin
export var closeButton = "smoke-module--close-button--xb7Zo";
export var container = "smoke-module--container---Iox7";
export var contentBox = "smoke-module--content-box--JOOGR";
export var iconBox = "smoke-module--icon-box--hFDKN";
export var link = "smoke-module--link--0XdxX";
export var logoBox = "smoke-module--logo-box--VnMSy";
export var text = "smoke-module--text--ileLS";
export var titleText = "smoke-module--title-text--c01oe";
export var unread = "smoke-module--unread--ppBou";